const component = {
  templateUrl: require('./joinSteps.html'),
  bindings: {
    currentStep : '<'
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/users/components/joinSteps.js